<template>
  <div id="DatePick">
    <p @click="selectDay=today" :class="{'active':selectDay == today}">今天</p>
    <p @click="selectDay=yesterday" :class="{'active':selectDay == yesterday}">昨天</p>
    <p @click="selectDay=beforeYesterday" :class="{'active':selectDay == beforeYesterday}">前天</p>
    <DatePicker
      @on-change="DatePickerDateChange"
      type="date"
      placeholder="请选择"
      style="width: 200px;margin-left:10px"
      :value="selectDay"
    ></DatePicker>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { mapState } from "vuex";
const today = dayjs(new Date()).format("YYYYMMDD");
const yesterday = dayjs(new Date())
  .add(-1, "day")
  .format("YYYYMMDD");
const beforeYesterday = dayjs(new Date())
  .add(-2, "day")
  .format("YYYYMMDD");

export default {
  name: "DatePick",
  props: {
    default: {
      type: String,
      default: today
    }
  },
  computed: {
    ...mapState(["device"])
  },
  data() {
    return {
      today,
      yesterday,
      beforeYesterday,
      selectDay: this.default
    };
  },
  watch: {
    selectDay() {
      this.$emit("onchange", this.selectDay);
    }
  },
  methods: {
    DatePickerDateChange(date) {
      this.selectDay = date.replace(/-/g, "");
    }
  }
};
</script>
<style lang="less" scoped>
#DatePick {
  display: flex;
  align-items: center;
  & > p {
    cursor: pointer;
    height: 1.7rem;
    line-height: 1.7rem;
    padding: 0 5px;
    font-size: 12px;
    &.active {
      background: #fa8e19;
      color: #fff;
      border-radius: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/components/DatePick.vue